<template>
	<div class="select-multiple-option">
		<Multiselect
			v-model="selected"
			:options="options"
			:placeholder="placeholder"
			:label="labelKey"
			:trackBy="valueKey"
			:searchable="searchable"
			:customLabel="customLabel"
			allowEmpty
			multiple
			selectLabel=""
			deselectLabel=""
			selectedLabel="Selected"
			@input="onInput"
		>
			<template #caret>
				<div class="caret">
					<i class="ic ic--arrow-select"></i>
				</div>
			</template>
			<template #selection>
				<template v-if="selected && selected.length > 0">
					{{ placeholder }} {{ selected.length > 0 ? ` (${selected.length})` : '' }}
				</template>
			</template>
		</Multiselect>
		<template v-if="!hideSelectionOuter">
			<div v-if="selected && selected.length > 0" class="flex mobileFlex">
				<div v-for="item in selected" :key="item[valueKey]" class="checked-sectors-name-btn flex">
					<h5>{{ item.text }}</h5>
					<button type="button" class="remove-btn" @click="removeOption(item)">
						<img :src="require('@/assets/images/Btn/remove-btn.png')" alt="" />
					</button>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
export default {
	name: 'SelectMultipleOption',
	components: { Multiselect },
	props: {
		value: {},
		options: {
			type: Array,
			default() {
				return []
			},
		}, // the options { value:'', label: '',}
		width: String,
		labelKey: {
			type: String,
			default: 'text',
		},
		valueKey: {
			type: String,
			default: 'value',
		},
		textHelper: String,
		placeholder: String,
		customLabel: {},
		searchable: Boolean,
		hideSelectionOuter: Boolean,
	},
	data() {
		return {
			open: null,
			selected: this.options?.filter((item) => this.value?.includes(item[this.valueKey])),
			tmp: null,
			popperOptions: {
				open: false,
			},
		}
	},

	methods: {
		onInput(val) {
			this.$emit(
				'input',
				val.map((item) => item[this.valueKey])
			)
			this.$emit('change', val)
		},
		removeOption(item) {
			let index = this.selected.findIndex((obj) => obj[this.valueKey] == item[this.valueKey])
			if (index >= 0) {
				this.selected.splice(index, 1)
			}
		},
	},
	watch: {
		value: {
			handler(val) {
				this.selected = this.options.filter((item) => val?.includes(item[this.valueKey]))
			},
			deep: true,
		},
	},
}
</script>

<style scoped lang="css">
.checked-sectors-name-btn {
	background: #f3f3f3;
	border-radius: 6px;
	padding: 10px 16px;
	display: flex;
	align-items: center;
	width: fit-content;
}

.checked-sectors-name-btn h5 {
	font-size: 1.8rem;
}

.checked-sectors-name-btn button {
	margin-left: 10px;
	background: none;
	border: none !important;
	outline: none;
	display: flex;
	align-items: center;
}

.checked-sectors-name-btn button img {
	width: 20px;
	height: 20px;
}
</style>
